'use client';

import { IBranch } from '@/_types';
import { getWhereToGoHref } from '@/_lib/brand-href';
import { Link } from '@/i18n/navigation';
import walletIcon from '@/shared/assets/svg/wallet.svg';
import { Box, Flex, HStack, IconButton, StackSeparator, Text } from '@chakra-ui/react';
import Image from 'next/image';
import { GoArrowLeft } from 'react-icons/go';
import BrandSelectMobile from './BrandSelectMobile';
import { useTranslations } from 'next-intl';
import timeIcon from '@/shared/assets/svg/time.svg';
import { StarIcon } from '@/_assets/icon-components';
import NumberToPrice from '@/_components/NumberToPrice';
import { LuSearch } from 'react-icons/lu';

interface RestaurantHeaderProps {
  branch: IBranch | null;
}

export function HeaderStatic({ branch }: RestaurantHeaderProps) {
  const t = useTranslations();

  if (!branch) return null;

  return (
    <Box px={2} shadow='md' borderBottomRadius='xl' bg='white'>
      <HStack justify='space-between' py='2'>
        <Link href='/where-to-go'>
          <IconButton aria-label='Back' variant='ghost' rounded='xl'>
            <GoArrowLeft strokeWidth='0.75' />
          </IconButton>
        </Link>

        <Link
          href={getWhereToGoHref(branch.shipper_id, branch.slug || branch.id, {
            path: '/search',
          })}
        >
          <IconButton aria-label='Search' variant='ghost' rounded='xl'>
            <LuSearch />
          </IconButton>
        </Link>
      </HStack>

      <Flex direction='column' p='4' pt='2' gap='4'>
        <BrandSelectMobile brandName={branch?.name || ''} />
        <HStack separator={<StackSeparator />}>
          <HStack>
            <StarIcon />
            <Box lineHeight={1.2} fontSize='xs'>
              <Text fontWeight={600}>
                {(branch?.rating || 5)?.toFixed(1)}
              </Text>
              <Text color='#A6A6A6'>{branch?.rating_count > 0 ? <>{branch?.rating_count > 999 ? '999+' : branch?.rating_count} {t('reviews')}</> : t('no_reviews')}</Text>
            </Box>
          </HStack>
            <HStack>
              <Image src={walletIcon} alt='' width={16} height={16} />
              <Box lineHeight={1.2} fontSize='xs'>
                <NumberToPrice value={branch?.avg_order_price || 120000} parentProps={{ fontWeight: 600 }} spanProps={{ fontWeight: 600 }} />
                <Text color='#A6A6A6'>{t('per_person')}</Text>
              </Box>
            </HStack>
          <HStack>
            <Image src={timeIcon} alt='' width={16} height={16} />
            <Box lineHeight={1.2} fontSize='xs'>
              <Text fontWeight={600}>
                {t('working_time')}
              </Text>
              <Text color='#A6A6A6'>До {branch?.close_time}</Text>
            </Box>
          </HStack>
        </HStack>
      </Flex>
    </Box>
  );
}
